import dayjs from 'dayjs';

import { DATE_KEY_FORMAT } from '@/helpers';

import { TimeOffBlockType } from '../types';
import {
  DayPortionDTO,
  TimeOffRequestStatusDTO,
} from '../types/dto/response/planner-timeoff-response';

interface OverlapCheckParams {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  doSkipWeekdays: boolean;
  timeOffs: TimeOffBlockType[];
}

/**
 * Checks whether every working day of a date range is covered by an approved full-day timeoff.
 * Used client-side before sending a drag/resize update to show a confirmation dialog.
 */
export function isAssignmentFullyOverlappedByTimeoffs(params: OverlapCheckParams): boolean {
  const { startDate, endDate, doSkipWeekdays, timeOffs } = params;

  const approvedFullDays = new Set<string>();
  for (const block of timeOffs) {
    if (block.status !== TimeOffRequestStatusDTO.APPROVED) continue;
    for (const day of block.originalTimeOff.days) {
      if (day.portion === DayPortionDTO.FULL) {
        approvedFullDays.add(dayjs(day.date).format(DATE_KEY_FORMAT));
      }
    }
  }

  if (approvedFullDays.size === 0) return false;

  let current = startDate;
  while (!current.isAfter(endDate, 'day')) {
    const dayOfWeek = current.day();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (!isWeekend || !doSkipWeekdays) {
      if (!approvedFullDays.has(current.format(DATE_KEY_FORMAT))) return false;
    }

    current = current.add(1, 'day');
  }

  return true;
}
